import { makeAutoObservable, runInAction } from "mobx";

import { apiService } from "../services";
import type {
  ReleaseVersion,
  ReleaseVersionFilters,
} from "../types/releaseNotes";
import type MainStore from "./MainStore";
import { WS_EVENTS } from "../types/wsEvents";

export default class ReleaseNotesStore {
  // Reference to MainStore (set by MainStore after creation) for this.mainStore.xStore
  mainStore: MainStore | null = null;

  isListLoading: boolean = false;
  releaseVersions: ReleaseVersion[] = [];
  filters: ReleaseVersionFilters = { page: 0, pageSize: 50, total: 0 };

  versionNotifications: ReleaseVersion | null = null;

  constructor(mainStore: MainStore) {
    makeAutoObservable(this, {
      mainStore: false, // reference only, don't make observable
    });
    this.mainStore = mainStore;

    if (typeof window !== "undefined") {
      window.addEventListener(WS_EVENTS.RELEASE_NOTE_PUBLISHED, (e: Event) => {
        this.handleReleaseNotePublished((e as CustomEvent).detail);
      });
    }
  }

  /** Surface a note pushed live over the WebSocket as a pending notification. */
  handleReleaseNotePublished = (note: ReleaseVersion | undefined | null) => {
    if (!note?.id) {
      return;
    }

    runInAction(() => {
      this.versionNotifications = note;
    });

    if (
      typeof window !== "undefined" &&
      window.location.pathname === "/release-notes"
    ) {
      this.loadReleaseVersions();
    }
  };

  clearVersionNotifications = () => {
    runInAction(() => {
      this.versionNotifications = null;
    });
  };

  loadReleaseVersions = async () => {
    runInAction(() => {
      this.isListLoading = true;
    });

    try {
      const versions = await apiService.getReleaseVersions();

      runInAction(() => {
        const { data, total } = versions;
        this.releaseVersions = data;
        this.filters = { ...this.filters, total };
      });
    } catch (error) {
      console.error("Error loading release versions:", error);
    } finally {
      runInAction(() => {
        this.isListLoading = false;
      });
    }
  };
}
